import React, { useEffect } from 'react';
import '../stylesheets/dashboard.scss';

function Signup() {

  return (
    <div className="dashboard-body">
        <h1>REVALIDATION</h1>
        <p>You have not subscribed to our Revalidation service.</p>
        <p>If you would like to learn more about our Revalidation service, please <a href="https://1664trainingsolutions.co.uk/revalidation-subscription" target="_blank" style={{fontFamily:"Garet Extra Bold"}} className="clickable-link">visit our website to learn more</a>.</p>
        <p>Think this is an error? <a href="mailto:hello@mpoweringsolutions.co.uk" className="clickable-link">Let us know</a> and we'll look into it.</p>
    </div>
  )
}

export default Signup